var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "gray-0-bkg pack-product p-3 br" }, [
    _c(
      "div",
      { staticClass: "flex-level flex-top" },
      [
        _c("span", { staticClass: "pack-product-title bold" }, [
          _vm._v(_vm._s(_vm.product.title))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "m-0 px-4" }, [
          _vm._v(_vm._s(_vm.product.printableShortDescription))
        ]),
        _vm._v(" "),
        _c(
          "el-tooltip",
          {
            attrs: {
              disabled: !_vm.isLock || !_vm.isClient,
              placement: "bottom-start"
            },
            model: {
              value: _vm.lockState,
              callback: function($$v) {
                _vm.lockState = $$v
              },
              expression: "lockState"
            }
          },
          [
            _c("span", {
              attrs: { slot: "content" },
              domProps: { innerHTML: _vm._s(_vm.lockContent) },
              slot: "content"
            }),
            _vm._v(" "),
            _c("el-switch", {
              ref: "pack-active-switch",
              staticClass: "pack-switch",
              attrs: {
                disabled: _vm.isLock && _vm.isClient,
                "inactive-color": "#565665",
                "active-color": "#39CF86"
              },
              model: {
                value: _vm.isActive,
                callback: function($$v) {
                  _vm.isActive = $$v
                },
                expression: "isActive"
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm.isActive
      ? _c(
          "div",
          { ref: "pack-options", staticClass: "flex-level flex-top mt-3" },
          [
            _c(
              "div",
              { staticClass: "w-80" },
              [
                _c("SaasIcon", {
                  attrs: { icon: "rocketchartLogo", width: "72", height: "18" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.isGrouped
              ? _c(
                  "div",
                  { staticClass: "ml-3" },
                  [
                    _c(
                      "el-tooltip",
                      {
                        ref: "sub-plan-tooltip",
                        attrs: {
                          disabled: !_vm.isLock || !_vm.isClient,
                          placement: "bottom-start"
                        },
                        model: {
                          value: _vm.planState,
                          callback: function($$v) {
                            _vm.planState = $$v
                          },
                          expression: "planState"
                        }
                      },
                      [
                        _c("span", {
                          attrs: { slot: "content" },
                          domProps: { innerHTML: _vm._s(_vm.lockContent) },
                          slot: "content"
                        }),
                        _vm._v(" "),
                        _c(
                          "el-select",
                          {
                            ref: "other-plan-select",
                            staticClass: "block w-160 mb-2",
                            attrs: {
                              value: _vm.product.code,
                              disabled: _vm.isLock && _vm.isClient
                            },
                            on: { change: _vm.handlePlanChange }
                          },
                          _vm._l(_vm.product.otherPlans, function(plan) {
                            return _c("el-option", {
                              key: plan,
                              attrs: {
                                label: _vm._f("capitalize")(
                                  _vm.labelOtherPlan(plan)
                                ),
                                value: plan
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "semibold",
                        attrs: { href: _vm.product.link, target: "_blank" }
                      },
                      [_vm._v(_vm._s(_vm.$l10n.__("Comparer les plans")))]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "flex-level ai-center ml-3",
                class: { "h-32": _vm.isClient }
              },
              [
                !_vm.isClient
                  ? _c(
                      "el-select",
                      {
                        staticClass: "pack-product-amount",
                        attrs: { disabled: _vm.isFree },
                        on: { change: _vm.emit },
                        model: {
                          value: _vm.packPrice.unit_amount,
                          callback: function($$v) {
                            _vm.$set(_vm.packPrice, "unit_amount", $$v)
                          },
                          expression: "packPrice.unit_amount"
                        }
                      },
                      _vm._l(_vm.allowedAmounts, function(amount) {
                        return _c("el-option", {
                          key: amount.amount,
                          attrs: { label: amount.label, value: amount.amount }
                        })
                      }),
                      1
                    )
                  : [
                      _vm.packPrice.unit_amount < _vm.basePrice && !_vm.isFree
                        ? _c(
                            "span",
                            {
                              ref: "pack-base-price",
                              staticClass: "strike grey semibold fs-2 mr-2"
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm._f("numberformatWithOptions")(
                                      _vm._f("floatNumber")(
                                        _vm.getPriceAmountByMonth(_vm.basePrice)
                                      ),
                                      _vm.numformat,
                                      true
                                    )
                                  ) +
                                  "\n                "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "span",
                        { ref: "pack-price", staticClass: "fs-3 semibold" },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm._f("numberformatWithOptions")(
                                  _vm._f("floatNumber")(
                                    _vm.getPriceAmountByMonth(
                                      _vm.packPrice.unit_amount
                                    )
                                  ),
                                  _vm.numformat,
                                  true
                                )
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    ],
                _vm._v(" "),
                _c("span", { class: { "ml-2": !_vm.isClient } }, [
                  !_vm.isClient
                    ? _c("span", { staticClass: "semibold" }, [_vm._v("€")])
                    : _vm._e(),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$l10n.__("/mois")) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                !_vm.isClient
                  ? _c(
                      "el-checkbox",
                      {
                        ref: "pack-free-checkbox",
                        staticClass: "ml-5",
                        model: {
                          value: _vm.isFree,
                          callback: function($$v) {
                            _vm.isFree = $$v
                          },
                          expression: "isFree"
                        }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$l10n.__("Offert")) +
                            "\n            "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isFree && _vm.isClient
                  ? _c(
                      "el-tag",
                      {
                        staticClass: "ml-3",
                        attrs: { effect: "dark", type: "success", size: "mini" }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$l10n.__("Offert")) +
                            "\n            "
                        )
                      ]
                    )
                  : _vm._e()
              ],
              2
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }